import { createContext } from 'react';
import {
  AccountDrawerAccountContextType,
  AccountDrawerCallGuardContextType,
  AccountDrawerContextType,
  AccountDrawerOpenersContextType,
  AccountDrawerSelectionContextType,
} from './types';

// Context objects live in their own non-component module so their identity
// survives React Fast Refresh — a module mixing createContext() with
// components/hooks gets fully re-executed on hot reload, which would create
// new context instances the already-mounted provider doesn't know about.

export const AccountDrawerContext = createContext<
  AccountDrawerContextType | undefined
>(undefined);
AccountDrawerContext.displayName = 'AccountDrawerContext';

/** Stable opener actions only — see AccountDrawerOpenersContextType. */
export const AccountDrawerOpenersContext = createContext<
  AccountDrawerOpenersContextType | undefined
>(undefined);
AccountDrawerOpenersContext.displayName = 'AccountDrawerOpenersContext';

export const AccountDrawerSelectionContext = createContext<
  AccountDrawerSelectionContextType | undefined
>(undefined);
AccountDrawerSelectionContext.displayName = 'AccountDrawerSelectionContext';

export const AccountDrawerAccountContext = createContext<
  AccountDrawerAccountContextType | undefined
>(undefined);
AccountDrawerAccountContext.displayName = 'AccountDrawerAccountContext';

export const AccountDrawerCallGuardContext = createContext<
  AccountDrawerCallGuardContextType | undefined
>(undefined);
AccountDrawerCallGuardContext.displayName = 'AccountDrawerCallGuardContext';
